const userSettingsEndpoint = `${process.env.VUE_APP_URL}/api/user/settings`
export default {
  namespaced: true,
  state: {
    model: {},
    scenario: {},
    beta: false,
    thirdFourthManagementTab: 0,
  },
  getters: {},
  mutations: {
    SET_MODEL(state, model) {
      state.model = model;
      state.scenario = null;
      state.thirdFourthManagementTab = 0
    },
    SET_SCENARIO(state, scenario) {
      state.scenario = scenario;
      state.thirdFourthManagementTab = 0
    },
    UPDATE_MODEL(state,model){
      if(state.model.id != model.id){
        return;
      }
      state.model = model
      state.thirdFourthManagementTab = 0
    },
    CLEAR_SCENARIO(state) {
      state.scenario = null;
      state.thirdFourthManagementTab = 0
    },
    CLEAR_MODEL(state) {
      state.model = null;
      state.thirdFourthManagementTab = 0
    },
    SET_TABS(state,tab){
      state.thirdFourthManagementTab = tab
    }
  },
  actions: {
    clearSelectedScenario({ commit, state }, id) {
      if (state.scenario && state.scenario.id == id) {
        commit("CLEAR_SCENARIO")
      }
    },
    clearSelectedModel({ commit, state }, id) {
      if (state.model && state.model.id == id) {
        commit("CLEAR_SCENARIO")
        commit("CLEAR_MODEL")
      }

    }
  },
}
